import { Component } from '@angular/core';
import { GlobalStylerComponent } from 'sf-components';
import { RouterLink, RouterOutlet, Router } from '@angular/router';
import { callApi, sfAlert } from 'sf-frontend';
import { AuthService } from './services/auth.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: true,
	imports: [GlobalStylerComponent, RouterLink, RouterOutlet],
})
export class AppComponent {
	public title = 'angular-frontend';

	public constructor(
		private readonly router: Router,
		public readonly authService: AuthService
	) {
		callApi.subscribeToVersionMismatchError(() => {
			void sfAlert('A new version is available. Please refresh your browser.').then(() => {
				window.location.reload();
			});
		});

		callApi.subscribeToNotAuthenticatedError(() => {
			void this.router.navigate(['/login']);
		});
	}

	public logout(): void {
		void this.authService.logout();
	}
}
